import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;

  max-inline-size: 328px;
  min-block-size: 500px;
  padding: 28px;

  color: #a1a1a1;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 120%;

  border-radius: 12px;

  background: #30343c;

  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
`;

export const Tnc = styled.p`
  a {
    display: inline;

    color: #a1a1a1;
    text-decoration: underline;
  }
`;

export const LoginForm = styled.div`
  & #sa-login-widget-title {
    margin-block: 0;
    margin-block-end: 28px;

    color: #ffffff;
    font-weight: 400;
    font-size: 24px;
    font-family: ${fontRobotoCondensed};
    font-style: normal;
    line-height: normal;
    text-align: start;
  }

  & {
    .sa-confirm-email-description,
    .sa-description,
    #sa-login-widget-title,
    .sa-confirm-current-email,
    .sa-current-email,
    .sa-send-again-description,
    .sa-login-with-social {
      inline-size: 100%;

      color: #ffffff;
      text-align: start;
    }
  }

  & #sa-forgot-password-email-sent-text {
    > strong {
      color: #4585ff;
    }
  }

  & .sa-form-message-label {
    inline-size: 100%;
    padding: 0;

    text-align: start;
    &:before {
      display: none;
    }
  }

  & .sa-login-button,
  & .sa-forgot-password-ok-button {
    color: #ffffff;

    background-color: #4585ff;
  }

  & .sa-next-step-button {
    margin-block-start: 12px;

    color: #ffffff;

    background-color: #4585ff;
    &.sa-next-step-button--disabled {
      color: #666666;

      background-color: #d7d7d7;
    }
  }
`;

export const Headline = styled.h2`
  color: #ffffff;
  font-size: 24px;
  font-family: ${fontRobotoCondensed};
  line-height: 100%;
`;
